var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.banner)?_c('div',{staticClass:"banner p-relative"},[_c('img',{attrs:{"src":_vm.banner.image_url}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }